"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoteEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../_util/utils");
var _text = _interopRequireDefault(require("../../text"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NoteEditor = _ref => {
  let {
    value = '',
    disabled,
    palceholder,
    onCheck,
    rules,
    inputWidth,
    ...restProps
  } = _ref;
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  const [editing, onEditingChange] = (0, _react.useState)(false);
  if (disabled) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_text.default, {
      children: value || '-'
    });
  }
  if (editing || value) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_text.default, {
      editable: {
        editing,
        onEditingChange,
        onCheck,
        inputWidth,
        rules
      },
      children: value
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
    ...attrs.data,
    className: "note-editor-placeholder",
    onClick: () => {
      onEditingChange(true);
    },
    children: palceholder
  });
};
exports.NoteEditor = NoteEditor;